export default __webpack_public_path__ + "static/media/Award_Statue_Character_Silver.256.3c8aeb85.png";